import { render, staticRenderFns } from "./UpdateAppraisal.vue?vue&type=template&id=179b5d45&scoped=true&"
import script from "./UpdateAppraisal.vue?vue&type=script&lang=ts&"
export * from "./UpdateAppraisal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateAppraisal.vue?vue&type=style&index=0&id=179b5d45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b5d45",
  null
  
)

export default component.exports